import type { ContentPage } from "@/lib/content/types";

// CRM › CRM Analytics › KPIs (leaf).
export const kpis: ContentPage = {
  slug: "crm-analytics/kpis",
  template: "hrmsFeature",
  seo: {
    title: "Sales KPI Dashboards - Track Key Metrics | GetBiz CRM",
    description: "Track sales KPIs in GetBiz CRM — win rate, cycle length, pipeline value, quota attainment — against targets with real-time dashboards.",
    keywords: ["sales kpi", "crm kpi dashboard", "sales metrics", "kpi tracking software"],
    ogImage: "/assets/data/seoimages/kpis.webp",
  },
  leaf: {
    hero: {
      caption: "KPIs",
      title: "Track the Metrics That Drive Revenue",
      description: "Set targets and monitor sales KPIs — win rate, cycle time, pipeline value and more — against goals in real time.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose KPIs",
      bullets: [
        { title: "Goal vs Actual", description: "Track every KPI against its target in real time." },
        { title: "Rep & Team Views", description: "See performance by rep, team or region." },
        { title: "Leading Indicators", description: "Watch activity metrics that predict results." },
        { title: "Alerts", description: "Get notified when a KPI drifts off target." },
      ],
      image: "/assets/images/img/product/crm/kpis-lead-image.webp",
      imageAlt: "KPIs — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of CRM Analytics",
      description: "KPIs connects to every other part of CRM Analytics in GetBiz CRM.",
    },
    cards: [
      { title: "Reports", href: "/crm-software/crm-analytics/reports/", description: "Create, filter and schedule reports on leads, deals, activity and revenue.", image: "/assets/images/img/product/crm/reports.webp", imageAlt: "GetBiz CRM reports" },
      { title: "Charts", href: "/crm-software/crm-analytics/charts/", description: "Turn any report into clear bar, line, pie or funnel charts so trends and outliers jump out instantly.", image: "/assets/images/img/product/crm/charts.webp", imageAlt: "GetBiz CRM charts" },
      { title: "Cohorts", href: "/crm-software/crm-analytics/cohorts/", description: "Group leads and customers into cohorts to see how conversion, retention and value change across segments and time.", image: "/assets/images/img/product/crm/cohorts.webp", imageAlt: "GetBiz CRM cohorts" },
      { title: "Funnels", href: "/crm-software/crm-analytics/funnels/", description: "Visualize your pipeline as a funnel to find the stages where deals stall, so you know precisely where to improve.", image: "/assets/images/img/product/crm/Funnels.webp", imageAlt: "GetBiz CRM funnels" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See KPIs in action.",
    relatedBlogs: "static",
    metaKey: "crm-analytics-kpis",
  },
  sections: [],
};
